import { I18N_TEXT } from '@/data/i18n'
import useCurrentPage from '@/hooks/use-current-page'
import { replaceTextStringWithVars } from '@/utils/format'
import { useCallback } from 'react'

function getTextsToUse(language: string) {
  return I18N_TEXT[language as keyof typeof I18N_TEXT]
}

export const geti18nText = (language: string, key: string, variables?: Record<string, string | number>) => {
  const textToUse = getTextsToUse(language)
  if (!textToUse) return `[MISSING LANGUAGE ${language}]`
  let textString: string = textToUse[key as keyof typeof textToUse]
  if (!textString) return `[MISSING TEXT KEY ${key}]`

  if (variables) {
    textString = replaceTextStringWithVars(textString, variables)
  }

  return textString
}

export type ValidI18nKey = keyof (typeof I18N_TEXT)[keyof typeof I18N_TEXT]
export type I18nFunction = (key: ValidI18nKey, variables?: Record<string, string | number>) => string | undefined

const useI18n = () => {
  const { currentLanguage } = useCurrentPage()

  const i18n = useCallback(
    (key: ValidI18nKey, variables?: Record<string, string | number>) => {
      return geti18nText(currentLanguage as string, key, variables)
    },
    [currentLanguage],
  )

  const isValidI18nKey = useCallback(
    (key: string | undefined): key is ValidI18nKey => {
      return !!key && key in getTextsToUse(currentLanguage as string)
    },
    [currentLanguage],
  )

  return { i18n, isValidI18nKey }
}

useI18n.displayName = 'useI18n'

export default useI18n
